const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'

const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY)
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken)
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY)
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  saveRefreshToken(refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  },

  removeRefreshToken() {
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  },

  decode(token) {
    if (!token) return null

    const parts = token.split('.')
    var encoded = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    switch (encoded.length % 4) {
      case 0:
        break
      case 2:
        encoded += '=='
        break
      case 3:
        encoded += '='
        break
    }
    return JSON.parse(decodeURIComponent(atob(encoded)))
  },

  isValid(token) {
    const decoded = this.decode(token)

    if (typeof decoded.exp === 'undefined') return false
    var deadline = new Date(0)
    deadline.setUTCSeconds(decoded.exp)

    const now = new Date()
    return deadline.valueOf() > now.valueOf()
  }
}

export { TokenService }
